import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { defaultLang } from "@/static/locales";

interface LangState {
  lang: string;
  setLang: (lang: string) => void;
}

const useLangStore = create<LangState>()(
  persist(
    (set, get) => ({
      lang: defaultLang,
      setLang: (lang: string) => set({ lang: lang }),
    }),
    {
      name: "bisw-locales", // unique name
      storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
    }
  )
);

export default useLangStore;
